import { render, staticRenderFns } from "./editable.vue?vue&type=template&id=6f4acd2e&scoped=true"
import script from "./editable.vue?vue&type=script&lang=ts"
export * from "./editable.vue?vue&type=script&lang=ts"
import style0 from "./editable.vue?vue&type=style&index=0&id=6f4acd2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4acd2e",
  null
  
)

export default component.exports